(function(app) {

    app.provider("reportApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {};

                        service.get = function(reportId) {
                            return crmApiGateway.get("/Reports/" + reportId);
                        };

                        service.getReports = function() {
                            return crmApiGateway.getArray("/Reports");
                        };

                        service.getPublicReports = function() {
                            return crmApiGateway.getArray("/Reports/Public");
                        };

                        service.getSharedReport = function(sharedReportId) {
                            return crmApiGateway.get("/Reports/Shared/" + sharedReportId);
                        };

                        service.getUserReports = function(userId) {
                            return crmApiGateway.getArray("/Users/" + userId + "/Reports");
                        };

                        service.getUserSharedReports = function(userId) {
                            return crmApiGateway.getArray("/Users/" + userId + "/Reports/Shared");
                        };

                        service.getExportedReport = function(exportedReportId) {
                            return crmApiGateway.getFile("/Reports/Exported/" + exportedReportId);
                        };

                        service.updateAccountReport = function(reportId, report) {
                            return crmApiGateway.put("/Reports/Account/" + reportId, report);
                        };

                        service.updateAppointmentReport = function (reportId, report) {
                            return crmApiGateway.put("/Reports/Appointment/" + reportId, report);
                        };

                        service.updateClientReport = function (reportId, report) {
                            return crmApiGateway.put("/Reports/Client/" + reportId, report);
                        };

                        service.updateClientReferralReport = function (reportId, report) {
                            return crmApiGateway.put("/Reports/ClientReferral/" + reportId, report);
                        };

                        service.updateScheduledTaskReport = function (reportId, report) {
                            return crmApiGateway.put("/Reports/ScheduledTask/" + reportId, report);
                        };

                        service.createAccountReport = function(report) {
                            return crmApiGateway.post("/Reports/Account", report);
                        };

                        service.createAppointmentReport = function(report) {
                            return crmApiGateway.post("/Reports/Appointment", report);
                        };

                        service.createClientReport = function(report) {
                            return crmApiGateway.post("/Reports/Client", report);
                        };

                        service.createClientReferralReport = function (report) {
                            return crmApiGateway.post("/Reports/ClientReferral", report);
                        };

                        service.createScheduledTaskReport = function (report) {
                            return crmApiGateway.post("/Reports/ScheduledTask", report);
                        };

                        service.createSharedReport = function(userId, reportId) {
                            return crmApiGateway.post("/Users/" + userId + "/Reports/" + reportId + "/Shared");
                        };

                        service.runReport = function (report, nextPageToken) {
                            var url = "/Reports/Run";
                            if (nextPageToken)
                                url += "?nextPageToken=" + nextPageToken;
                            return crmApiGateway.post(url, report);
                        };

                        service.export = function (report) {
                            return crmApiGateway.post("/Reports/Exported", report);
                        };

                        service.deleteReport = function(reportId) {
                            return crmApiGateway.delete("/Reports/" + reportId);
                        };

                        service.deleteSharedReport = function (sharedReportId) {
                            return crmApiGateway.delete("/Reports/Shared/" + sharedReportId);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line